// extracted by mini-css-extract-plugin
export default {"proposalWrap":"Proposal_proposalWrap__yjYIY"};